import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Input } from "@/components/ui/input";

export const PatientPicker = ({ value, onChange, initial = "" }) => {
  const [q, setQ] = useState(initial);
  const term = q.trim();
  const { data = [], isFetching } = useQuery({ queryKey: ["patient-pick", term], enabled: term.length >= 2,
    queryFn: async () => (await api.get("/patients", { params: { search: term } })).data });

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm" data-testid="patient-picker-selected">
        <span className="font-medium text-slate-800">{value.first_name} {value.last_name}
          {value.date_of_birth && <span className="ml-2 text-xs text-slate-500">DOB {fmtDate(value.date_of_birth)}</span>}</span>
        <button type="button" className="text-xs font-semibold text-[#0B1F44] hover:underline" data-testid="patient-picker-change" onClick={() => onChange(null)}>Change</button>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      <Input data-testid="patient-picker-search" placeholder="Search patient by name or phone" value={q} onChange={(e) => setQ(e.target.value)} />
      {term.length >= 2 && (
        <div className="max-h-48 overflow-y-auto rounded-md border border-slate-200 bg-white text-sm">
          {isFetching && <p className="px-3 py-2 text-slate-400">Searching…</p>}
          {!isFetching && data.length === 0 && <p className="px-3 py-2 text-slate-400">No patients found</p>}
          {data.slice(0, 20).map((p) => (
            <button key={p.id} type="button" data-testid={`patient-picker-option-${p.id}`} onClick={() => onChange(p)}
              className="block w-full px-3 py-2 text-left hover:bg-slate-50">
              <span className="font-medium text-slate-800">{p.first_name} {p.last_name}</span>
              {p.date_of_birth && <span className="ml-2 text-xs text-slate-500">DOB {fmtDate(p.date_of_birth)}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
